import axiosClient from './axiosClient';

export interface BidAnalysisDto {
  id: string;
  opportunityId: string;
  status: 'PENDING' | 'RUNNING' | 'COMPLETED' | 'FAILED';
  recommendation?: string;
  confidence?: number;
  reasoning?: string;
  riskFactors?: string[];
  flipToBidSuggestions?: string[];
  overallScore?: number;
  summary?: string;
  errorMessage?: string;
  modelUsed?: string;
  tokensUsed?: number;
  knowledgeArticleId?: string;
  triggeredByName?: string;
  startedAt?: string;
  completedAt?: string;
  createdAt?: string;
}

export const bidAnalysisApi = {
  trigger: (opportunityId: string) =>
    axiosClient.post<BidAnalysisDto>(`/opportunities/${opportunityId}/bid-analysis`),

  getLatest: (opportunityId: string) =>
    axiosClient.get<BidAnalysisDto>(`/opportunities/${opportunityId}/bid-analysis/latest`),

  getAll: (opportunityId: string) =>
    axiosClient.get<BidAnalysisDto[]>(`/opportunities/${opportunityId}/bid-analysis/all`),
};
